/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Footer_LegalInputs */

const en_wc_footer_legal = /** @type {(inputs: Wc_Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help & policies`)
};

/**
* | output |
* | --- |
* | "Help & policies" |
*
* @param {Wc_Footer_LegalInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_footer_legal = /** @type {((inputs?: Wc_Footer_LegalInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Footer_LegalInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_footer_legal(inputs)
});
export { wc_footer_legal as "wc.footer.legal" }